import { render, staticRenderFns } from "./FloorPrice.vue?vue&type=template&id=8b834442&"
import script from "./FloorPrice.vue?vue&type=script&lang=js&"
export * from "./FloorPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports